import { Component, OnInit } from '@angular/core';
import { BannerAppComponent } from "../../banner-app/banner-app.component";
import { FooterAppComponent } from "../../footer-app/footer-app.component";
import { ActivatedRoute, Router } from '@angular/router';
import { NgOptimizedImage } from '@angular/common';

@Component({
    selector: 'app-fin-flujo',
    standalone: false,
    templateUrl: './fin-flujo.component.html',
    styleUrl: './fin-flujo.component.scss',
})
export class FinFlujoComponent implements OnInit {
    sessionId: string = '';

    constructor(
        private router: Router,
        private route: ActivatedRoute
    ) {

    }

    getLocalStorage(): number {
        return Number(localStorage.getItem('session_id'))
    }

    ngOnInit(): void {
        this.sessionId = this.getLocalStorage().toString();
    }

    volverInicio(): void {
        this.router.navigate(['./']);
    }
}
